import React, { type ReactNode } from 'react';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightTarget as SpotlightTargetOriginal } from '@atlaskit/onboarding';

// Copied from @atlaskit/onboarding since it isn't exported
type TargetRef = (element: HTMLElement | null | undefined) => void;
type RenderChildrenFunction = (props: { targetRef?: TargetRef }) => ReactNode;

export interface SpotlightTargetProps {
	/**
	 * A single child.
	 */
	children: ReactNode | RenderChildrenFunction;
	/**
	 * The name to reference from Spotlight.
	 */
	name: string;
}

export const SpotlightTarget = ({
	children,
	...props
}: SpotlightTargetProps): React.JSX.Element => (
	<SpotlightTargetOriginal {...props}>
		{/*
		 * The atlaskit spotlight target component merely registers a ref on the child component,
		 *  so there is no way to give it a test id. We want to keep the test id as closely coupled
		 *  with the target as possible, so we add a span with id here, rather than on the child
		 *  where it could become more easily uncoupled.
		 */}
		{/* @ts-expect-error - TS2322 - Type '{ children: ReactNode | RenderChildrenFunction; }' is not assignable to type '{ children?: ReactNode; }'. */}
		<span data-testid={`ak-spotlight-target-${props.name}`}>{children}</span>
	</SpotlightTargetOriginal>
);
